import React from 'react';
import { getGradeColor } from '../../../../utils/gradeColors';
import Modal, {
  ModalPrimaryButton,
  ModalSecondaryButton,
} from '../../../common/Modal';

const DeleteGradeModal = ({
  show,
  grade,
  onConfirm,
  onCancel,
  loading
}) => {
  if (!show || !grade) return null;

  return (
    <Modal
      isOpen
      onClose={onCancel}
      title="Delete grade?"
      icon="fa-exclamation-triangle"
      tone="danger"
      size="md"
      closeOnBackdrop={!loading}
      closeOnEscape={!loading}
      footer={
        <>
          <ModalSecondaryButton onClick={onCancel} disabled={loading}>
            Cancel
          </ModalSecondaryButton>
          <ModalPrimaryButton
            onClick={onConfirm}
            loading={loading}
            loadingText="Deleting..."
            tone="danger"
          >
            <i className="fas fa-trash"></i>
            Delete grade
          </ModalPrimaryButton>
        </>
      }
    >
      <div className="rounded-xl border border-pale-dawn bg-ice-white/60 p-4 space-y-2">
        <div className="flex justify-between items-center">
          <span className="text-sm text-slate-cloud">Grade</span>
          <span
            className="text-sm font-semibold px-2 py-1 rounded bg-white border border-pale-dawn"
            style={{ color: getGradeColor(grade.gradeValue) }}
          >
            {grade.gradeValue}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-slate-cloud">Weight</span>
          <span className="text-sm font-medium text-grey-dusk">
            {grade.weight || 1.0}
          </span>
        </div>
        {grade.description && (
          <div className="flex justify-between items-start gap-3">
            <span className="text-sm text-slate-cloud shrink-0">
              Description
            </span>
            <span className="text-sm font-medium text-grey-dusk text-right break-words">
              {grade.description}
            </span>
          </div>
        )}
        {grade.examDate && (
          <div className="flex justify-between items-center">
            <span className="text-sm text-slate-cloud">Date</span>
            <span className="text-sm font-medium text-grey-dusk">
              {grade.examDate}
            </span>
          </div>
        )}
      </div>

      <p className="mt-4 text-sm text-slate-cloud">
        This cannot be undone - the grade is permanently removed from the
        records.
      </p>
    </Modal>
  );
};

export default DeleteGradeModal;
